export const environment = {
    production: true,

    ApiBase: "./CustomerPortal.API/",

    ImageLocation: "assets/",
    LocalImageLocation: "assets/",
    PageIcon: "assets/icons/favicon-bms.png",

    DocumentLocation: "assets/documents/",

    System: "BMS"
};
